import { render } from "./Footer.vue?vue&type=template&id=4f3c4876"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=4f3c4876&lang=scss"
script.render = render

export default script